module.exports = __webpack_public_path__ + "img/ico-list.e9f2f230.svg";